module.exports = __webpack_public_path__ + "img/jpeg.9e748e9f.svg";